// extracted by mini-css-extract-plugin
export default {"waves":"_8LA0QWYu","_customBg":"XPjrJ_Xd"};